import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

let cachedToken: string | null = null;

export const useMapboxToken = () => {
  const [token, setToken] = useState<string | null>(cachedToken);
  const [isLoading, setIsLoading] = useState(!cachedToken);

  useEffect(() => {
    if (cachedToken) {
      setToken(cachedToken);
      setIsLoading(false);
      return;
    }

    const fetchToken = async () => {
      try {
        const { data, error } = await supabase.functions.invoke("get-mapbox-token");
        if (error) throw error;
        if (data?.token) {
          cachedToken = data.token;
          setToken(data.token);
        }
      } catch (err) {
        console.error("Failed to fetch Mapbox token:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchToken();
  }, []);

  return { token, isLoading };
};
